<template>
  <div class="modal-drag-custom-drag" :class="$vuetify.breakpoint.mobile && 'mobile-popup'" :style="{ zIndex: indexModalIndex }">
		<modal
			name="custom_drag_modal"
			:style="{ zIndex: indexModalIndex }"
			hide-overlay
			draggable=".drag-header"
			:clickToClose="true"
			@before-close="closeModal"
			:focusTrap="true"
			:adaptive="true"
			height="auto"
		>
      <v-card>
        <v-card-title class="pa-0 drag-header">
					<div class="d-flex flex-row align-center justify-space-between py-2 px-8 w-100">
						<div class="d-flex flex-row align-center">
							<p class="mb-0 font-weight-bold text-primary title">Etapa</p>
						</div>
						<v-btn class="mx-2" fab dark small color="#FF1209" @click="closeModal">
							<v-icon dark>mdi-close</v-icon>
						</v-btn>
					</div>
				</v-card-title>
        <v-card-text class="pa-0">
          <div class="py-4 px-8">
            <v-form ref="form" v-model="validform" class="mt-6">
							<div class="d-flex align-center justify-space-between mb-4">
								<div v-if="isGeneralStage">
									<p class="mb-0 font-weight-bold caption">Etapa Para Zona</p>
									<p class="mb-0" style="font-size: 10px">Etapa general para zona de proyecto</p>
								</div>
								<div v-else>
									<p class="mb-0 font-weight-bold caption">Etapa Específica</p>
									<p class="mb-0" style="font-size: 10px">Para la Zona y Tipo de Proyecto seleccionados</p>
								</div>
								<div class="d-flex flex-column align-center justify-center">
									<p class="mb-0 font-weight-bold" style="font-size: 10px">Tipo de Etapa</p>
									<v-switch
										class="mt-0"
										color="#FF120B"
										dense
										hide-details
										v-model="isGeneralStage"
									></v-switch>
								</div>
							</div>
							<div class="mb-2 d-flex align-center">
								<v-select
									v-model="selectedCategory"
									:items="categories"
									:menu-props="{ top: true, offsetY: true }"
									item-text="name"
									item-value="name"
									label="Etapas incluidas"
									outlined
									dense
									style="max-width:200px"
									required
									hide-details=""
									return-object
									@change="onChangeSelectedCategory"
								></v-select>
								<v-text-field
									v-show="selectedCategory?.name == 'Otro'"
									label="Agregar Nombre Etapa"
									v-model="newCategory.name"
									class="ml-2"
									outlined
									hide-details
									required
									dense
									:rules="requiredRule"
								></v-text-field>
							</div>
							<v-text-field
								label="Descripción Etapa (Opcional)"
								v-model="newCategory.description"
								outlined
								hide-details
								required
								dense
								class="mb-2"
							></v-text-field>
							<!-- <div class="d-flex align-center justify-space-between mb-4">
								<div>
									<p class="mb-0 font-weight-bold caption">Incluye Permiso</p>
									<p class="mb-0" style="font-size: 10px">Marca esta opción si esta etapa incluye la gestión de Permisos</p>
								</div>
								<div class="d-flex flex-column align-center justify-center">
									<v-switch
										class="mt-0"
										color="#FF120B"
										dense
										hide-details
										v-model="newCategory.with_permission"
									></v-switch>
								</div>
							</div>
							<div class="d-flex align-center justify-space-between mb-4">
								<div>
									<p class="mb-0 font-weight-bold caption">Incluye Recepción</p>
									<p class="mb-0" style="font-size: 10px">Marca esta opción si esta etapa incluye la Recepción Municipal</p>
								</div>
								<div class="d-flex flex-column align-center justify-center">
									<v-switch
										class="mt-0"
										color="#FF120B"
										dense
										hide-details
										v-model="newCategory.with_reception"
									></v-switch>
								</div>
							</div> -->

              <v-row align="center">
                <v-col cols="12">
                  <div class="d-flex flex-row justify-end">
                    <v-btn
                      class="mx-2 my-1"
                      color="white"
                      raised
                      @click="closeModal"
                    >
                      <p class="mb-0 text-primary">Cancelar</p>
                    </v-btn>
                    <v-btn
                      class="mx-2 my-1"
                      color="#524D4D"
                      raised
                      dark
                      :loading="loadingCreateCategory"
                      @click="confirmCategory"
                    >
                      <p class="mb-0">Confirmar</p>
                    </v-btn>
                  </div>
                </v-col>
              </v-row>
            </v-form>
          </div>
        </v-card-text>
      </v-card>
    </modal>
  </div>
</template>

<script>
import {createProjectPlanningCategory, updateProjectPlanningCategory} from '@/helpers/api/projects'

export default {
  name: 'NewProjectCategory',
	props: {
		reload: {
      type: Function,
      required: true
    }
	},
  data: () => ({
		indexModal: + new Date(),
    validform: true,
		loadingCreateCategory: false,
		isGeneralStage: false,
		selectedCategory: null,
		categories: [
			{
				name: 'Permiso',
				with_permission: true,
				with_reception: false
			},
			{
				name: 'Permiso y Recepción',
				with_permission: true,
				with_reception: true
			},
			{
				name: 'Recepción',
				with_permission: false,
				with_reception: true
			},
			{
				name: 'Otro',
				with_permission: false,
				with_reception: false
			},
		],
		newCategory: {
			name: null,
			description: null,
			order: 1,
			with_permission: false,
			with_reception: false
		},
    requiredRule: [
      v => !!v || 'Campo requerido'
    ]
  }),
  computed: {
		indexModalIndex(){
			const ordered = [...this.$store.state.general.openModalOrders].sort((a, b) => a - b)
			return ordered.indexOf(this.indexModal) + 10
		},
  },
  mounted(){
		if(this.$store.state.projects.categoryModalEditInfo){
			this.newCategory = {
				...this.newCategory,
				...this.$store.state.projects.categoryModalEditInfo
			}
			console.log(this.newCategory)
			this.isGeneralStage = !!this.newCategory.general_stage
		}
		this.$modal.show('custom_drag_modal')
			this.$store.commit('general/addOpenModalOrders', this.indexModal)
  },
  methods: {
		onChangeSelectedCategory(category){
			console.log('category', category)
			this.newCategory = {...this.newCategory, ...category}
		},
    closeModal(){
      this.$store.commit('projects/setCategoryModal', false)
      this.$store.commit('projects/setCategoryModalEditInfo', null)
			this.newCategory = {
				name: null,
				description: null,
				order: 1,
				with_permission: false,
				with_reception: false
			}
      this.validform = true
      this.loadingCreateCategory = false
    },
		async confirmCategory(){
			this.loadingCreateCategory = true
			this.newCategory.general_stage = this.isGeneralStage
			let category
			if(this.isGeneralStage){
				this.newCategory.project_type_id = null
			}
			console.log(this.newCategory)
			if (this.newCategory.project_planning_category_id) {
				category = await updateProjectPlanningCategory(this.newCategory);
			} else {
				category = await createProjectPlanningCategory(this.newCategory);
			}
			if(category.code == 200){
				this.reload()
				this.closeModal()
			}
			this.loadingCreateCategory = false
		},
    setMessage(messageData){
      const data = {
        message: messageData.message,
        title: messageData.title,
        created: new Date(),
        type: messageData.type,
        icon: messageData.icon,
        color: messageData.color,
      }
      this.$store.dispatch('general/addMessage', data)
    },
  }
};
</script>

<style scoped>
	.profile-avatar{
		cursor: pointer;
		position: relative;
		width: 200px;
	}
	.profile-image{
		width: 100%;
		height: 150px;
	}
	.logo-text{
		position: absolute;
		bottom: 0;
		background-color: rgba(0, 0, 0, 0.7);
		width: 100%;
		color: white;
		font-size: 12px;
		padding: 5px 10px;
	}
  .info-container{
    color: #606060;
  }
  .text-primary{
    color: #524D4D;
  }
  .info-icon{
    background-color: #524D4D;
    border-radius: 25px;
    padding: 3px;
    width: 35px;
    height: 35px;
  }
  .info-icon.small-icon{
    width: 25px;
    height: 25px;
  }
  .info-img{
    width: 100%;
    max-height: 50px;
    object-fit: contain;
  }
  .adjuntos-container{
    background-color: #EFEFEF;
    max-height: 95px;
    overflow-y: scroll;
  }
  .interaction-container{
    width: 100%;
    background-color: #E5E9F2;
    border-radius: 5px;
    position: relative;
    padding: 12px;
  }
  .user-avatar.small{
    width: 25px;
    height: 25px;
  }
  .light-blue-text{color: #959595;}
  .interaction-container .icon-arrow{
    font-size: 80px;
    position: absolute;
    top: 20px;
    line-height: inherit;
  }
  .interaction-container.right .icon-arrow{
    left: -46px;
  }
  .interaction-container.left .icon-arrow{
    right: -46px;
  }
  /deep/ .custom-input-numbers .v-input__slot{padding:0!important;}
  /deep/ .custom-input-numbers .v-input__prepend-inner,
  /deep/ .custom-input-numbers .v-input__append-inner,
  /deep/ .custom-text-input .v-input__append-inner{margin-top:0!important;}
  /deep/ .custom-input-numbers input {text-align: center }
</style>